/**
 * AccouPro — GST Verification API Client
 */

import { GSTVerifyApiResponse } from "@/types/gst";

function getHeaders(): Record<string, string> {
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  try {
    const sessionStr = localStorage.getItem("accoupro_auth_session");
    const userStr = localStorage.getItem("accoupro_auth_user");
    if (sessionStr) {
      const sess = JSON.parse(sessionStr);
      if (sess?.access_token) headers["Authorization"] = `Bearer ${sess.access_token}`;
    }
    if (userStr) {
      const u = JSON.parse(userStr);
      if (u?.id) headers["x-user-id"] = u.id;
      if (u?.role) headers["x-user-role"] = u.role;
      if (u?.company || u?.company_id) headers["x-company-id"] = u.company || u.company_id;
    }
  } catch {}
  return headers;
}

export async function verifyGSTINApi(gstin: string): Promise<GSTVerifyApiResponse> {
  const clean = (gstin || "").trim().toUpperCase();
  if (!clean) {
    return {
      success: false,
      source: "offline_extraction",
      status: "Invalid",
      error: "GSTIN is required for verification.",
      code: "MISSING_GSTIN",
    };
  }

  try {
    const res = await fetch("/api/gst/verify", {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify({ gstin: clean }),
    });

    const data = await res.json().catch(() => null);

    if (!res.ok) {
      return {
        success: false,
        source: data?.source || "offline_extraction",
        status: data?.status || "Invalid",
        error: data?.error || `Verification failed (HTTP ${res.status})`,
        code: data?.code || "HTTP_ERROR",
        data: data?.data,
      };
    }

    return data as GSTVerifyApiResponse;
  } catch (err: any) {
    return {
      success: false,
      source: "offline_extraction",
      status: "Unable to Verify",
      error: err.message || "Network error while connecting to GST verification service.",
      code: "NETWORK_ERROR",
    };
  }
}
